import rights from "../config/rights.json";
import { getAccessToken, getUserRights } from "./SecurityManager";

type Rights = Record<string, Record<string, string>>;

class Permissions {
    protected permissionsMap: Record<string, boolean> | null = null;

    canAccess = (resource: string, action?: string) => {
        // TODO: remove this check when all permissions are implemented
        // if (resource) {
        //     return true;
        // }
        if (!action || !resource) {
            return false;
        }

        const token = getAccessToken();
        if (!token) {
            return false;
        }

        if (!this.permissionsMap) {
            const permsArray = getUserRights();

            if (Array.isArray(permsArray)) {
                // creating permission map object instead of array for faster access
                /* eslint-disable no-param-reassign */
                this.permissionsMap = permsArray.reduce((acc: Record<string, boolean>, next: string) => {
                    acc[next] = true;
                    return acc;
                }, {});
            } else {
                return false;
            }
        }

        return this.permissionsMap ? this.permissionsMap[(rights as Rights)[resource]?.[action]] || false : false;
    };

    reset = () => {
        this.permissionsMap = null;
    };
}

const permissionsInstance = new Permissions();

export const { canAccess } = permissionsInstance;
export const permissionsReset = permissionsInstance.reset;
